export type LiveTranslationMissingFlags = {
  stagePlayer?: boolean;
  roomPlayer?: boolean;
  onlinePlayer?: boolean;
};

export type LiveTranslationPanelMode = 'hidden' | 'loading' | 'error' | 'ready';

export function resolveLiveTranslationPanelView(input: {
  featureLoading: boolean;
  hasAccess: boolean;
  hasStatus?: boolean;
  statusError?: boolean;
  entitled?: boolean;
  killSwitchOff?: boolean;
  translationTemplateMissing?: LiveTranslationMissingFlags;
}): {
  visible: boolean;
  mode: LiveTranslationPanelMode;
  /** Last known status is shown, but the latest refresh failed. */
  stale: boolean;
  entitled: boolean;
  missingStage: boolean;
  missingOnline: boolean;
} {
  const none = { stale: false, entitled: false, missingStage: false, missingOnline: false };
  if (input.featureLoading || !input.hasAccess) {
    return { visible: false, mode: 'hidden', ...none };
  }
  if (!input.hasStatus) {
    return { visible: true, mode: input.statusError ? 'error' : 'loading', ...none };
  }
  return {
    visible: true,
    mode: 'ready',
    stale: input.statusError === true,
    entitled: input.entitled !== false && !input.killSwitchOff,
    missingStage: input.translationTemplateMissing?.stagePlayer === true,
    missingOnline: input.translationTemplateMissing?.onlinePlayer === true,
  };
}

export type LiveTranslationIconState = 'unavailable' | 'off' | 'on';

/** Toolbar icon: grey when translation cannot run, default when it is off, primary when it is on. */
export function resolveLiveTranslationIconState(input: {
  mode: LiveTranslationPanelMode;
  entitled: boolean;
  enabled?: boolean;
}): LiveTranslationIconState {
  if (input.mode !== 'ready' || !input.entitled) return 'unavailable';
  return input.enabled === true ? 'on' : 'off';
}

export function liveTranslationStageCaptionPatch(stagePlayer: boolean): {
  captions: { stagePlayer: boolean };
} {
  return { captions: { stagePlayer } };
}
